<style lang="css">

.v-btn--active {
  background-color: #7a00cc;
}
.v-btn--active span {
  color: #ffffff;
}
.linechart {

}

</style>

<template>
<v-layout column wrap>

    <v-layout row wrap justify-center class="mt-4">
      <v-flex xs12 class="text-xs-center">
        <p class="text-xs-center blue-grey--text text--lighten-1 mb-1">{{content.graph}}</p>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap justify-center>
          <v-btn-toggle v-model="time" class="elevation-3" >
            <v-btn flat value="day">
              <span>24{{content.h}}</span>
            </v-btn>
            <v-btn flat value="week">
              <span>7 {{content.days}}</span>
            </v-btn>
            <v-btn flat value="month">
              <span>30 {{content.days}}</span>
            </v-btn>
            <v-btn flat value="year">
              <span>{{content.year}}</span>
            </v-btn>
          </v-btn-toggle>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout v-if="time" column wrap justify-center class="mt-2 mb-4" id="itemGraph">

        <div class="chart" v-if="!loading">
          <section v-if="!loading" :class="type == 4 ? 'type-4' : 'type-1'">
            <line-chart v-if="chartType === 'LineChart' && type > 0 && type < 4" :clabels="chartLabels" :cdata="chartData" class="linechart" :styles="styles"/>
            <timeline-chart v-if="TimelineData.length > 5" :time="time" :role="role" :chartData="TimelineData"/>
          </section>
        </div>
        <v-flex v-else xs12 class="text-xs-center progress pa-5">
          <v-progress-circular :size="100" :width="6" color="primary" indeterminate></v-progress-circular>
        </v-flex>

    </v-layout>

</v-layout>
</template>

<script>

import LineChart from "../tools/charts/linechart-chartsjs"
import TimelineChart from "../tools/charts/timelinechart"

export default {
    name: 'itemGraph',
    components: {
      LineChart, TimelineChart
    },
    props: ['slug', 'sensors', 'type', 'role', 'devmode'],
    data() {
        return {
            lang: null,
            loading: false,
            amount: this.type,
            time: '',

            chartType: 'LineChart',
            chartLabels: [],
            chartData: {},
            TimelineData: {},

            styles: {
              height: '300px',
            },
        }
    },
    created() {
        this.locale = Lang.get();
        this.setLang();
        this.startClean();
    },
    watch: {
        slug() {
            this.time = '';
            this.startClean();
        },
        time() {
          this.startClean();
          if (this.time) {
            this.startGraph();
          }
        },
        devmode(newDM, oldDM) {
          if ((oldDM == 0 && newDM != 0) || (oldDM != 0 && newDM == 0)) {
            this.startClean();
            this.startGraph();
          }

        },
    },
    methods: {
        startClean(){
          this.chartOptions = {};
          this.chartData = {};
        },
        startGraph() {
          this.getData();
        },
        getData() {
            this.loading = true;
            axios.post(`/api/switch/${this.slug}/sensors-data`, {
                time: this.time
            }).then(res => {
              if (this.type < 4) {
                if (res.data.success && Object.keys(res.data.success).length > 0) {
                  this.chartType = 'LineChart';
                  this.setLineData(res.data.success);
                } else {
                  this.chartType = '';
                  this.loading = false;
                }
              }
              this.TimelineData = res.data.success
              this.loading = false;
            }).catch(err => {
              console.error(err);
            });
        },
        setLineData(logs){
          let labels = [];
          let data = [];
          let time;
          if (this.type >= 1) {
            data.temperature = {
              label: this.content.temp,
              borderColor: '#247BA0',
              backgroundColor: '#247BA0',
              fill: false,
              data: [],
              yAxisID: "y-temp",
              type: 'line',
    					pointRadius: 2,
    					lineTension: 0,
    					borderWidth: 2
            }
          }
          if (this.type >= 2) {
            data.humidity = {
              label: this.content.humidity,
              borderColor: '#c934ac',
              backgroundColor: '#c934ac',
              fill: false,
              data: [],
              yAxisID: "y-humidity",
              type: 'line',
    					pointRadius: 2,
    					lineTension: 0,
    					borderWidth: 2
            }
          }
          if (this.type >= 3) {
            data.light = {
              label: this.content.light,
              borderColor: '#fc9600',
              backgroundColor: '#fc9600',
              fill: false,
              data: [],
              yAxisID: "y-light",
              type: 'line',
    					pointRadius: 2,
    					lineTension: 0,
    					borderWidth: 2
            }
          }
          for (let log in logs) {
            time = (logs[log].created_at * 1000);
            labels.push(time);
            if (this.type >= 1) {
              data.temperature.data.push(logs[log].temperature);
            }
            if (this.type >= 2) {
              data.humidity.data.push(logs[log].humidity);
            }
            if (this.type >= 3) {
              data.light.data.push(logs[log].light);
            }
          }
          this.chartLabels = labels;
          this.chartData = data;
          this.loading = false;
        },
        setTimelineData(logs){
          let labels = [];
          let data = [];
          let time;
          data = {
      			label: 'Status',
      			data: [],
      			borderColor: 'rgba(0, 0, 0, 0)',
      			backgroundColor: 'red',
      			fill: true,
            pointRadius: 4,
      		};
          for (let log in logs) {
            time = (logs[log].created_at * 1000);
            labels.push(time);
            let status = logs[log].status > 0 ? 1 : NaN;
            data.data.push(status);
          }
          this.chartLabels = labels;
          this.chartData = data;
          this.loading = false;
        },

        setLang() {
            if (this.locale == "en") {
                this.content = {
                    graph: 'Graph - select time',
                    h: 'H',
                    days: 'Days',
                    year: 'Year',
                    time: 'Time',
                    status: 'status',
                    temp: 'temperature',
                    humidity: 'humidity',
                    light: 'light',
                    click: 'Click and drag in the plot area to zoom in',
                    pinch: 'Pinch the chart to zoom in',
                };

            } else if (this.locale == "he") {
                this.content = {
                    graph: 'גרף - בחירת זמנים',
                    h: ' שעות',
                    days: 'ימים',
                    year: 'שנה',
                    time: 'זמן',
                    status: 'סטטוס',
                    temp: 'טמפרטורה',
                    humidity: 'לחות',
                    light: 'אור',
                    click: 'לחץ וגרור את שטח הגרף כדי להתקרב',
                    pinch: 'צבוט את התרשים כדי להתקרב',
                };
            }
        }
    },
}
</script>
